<div class="modal-overlay">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3>Map Canon Record</h3>
            <button class="close-btn" (click)="onCloseDialog()">✕</button>
        </div>
        <p class="modal-subtitle">
            Search and map entry to <strong>{{ targetCompanyName | titlecase }}</strong>
        </p>
        <div class="pb-4">
            <div class="search-wrapper">
                <span class="search-icon">🔍</span>
                <input type="text" placeholder="Search company..." [ngModel]="queryParameters$.value.companyName"
                    (input)="onCompanyNameChange($any($event.target).value)" />
            </div>
            <div class="d-flex gap-2">
                <div>
                    <label class="form-label text-header fw-semibold tracking-wide mb-1.5">Country</label>
                    <select class="form-select filter-dropdown filter" [ngModel]="queryParameters$.value.country"
                        (ngModelChange)="onCountryChange($event)">
                        @for(country of countryList; track $index){
                        <option [value]="country.name">{{country.name}}</option>
                        }
                    </select>
                </div>
                <div>
                    <label class="form-label text-header fw-semibold tracking-wide mb-1.5">Company Type</label>
                    <select class="form-select filter-dropdown filter" [ngModel]="queryParameters$.value.type"
                        (ngModelChange)="onCompanyTypeChange($event)">
                        <option value="">All </option>
                        <option value="buyer">Buyer</option>
                        <option value="seller">Seller</option>
                    </select>
                </div>
            </div>
        </div>
        @if (canonList$ | async; as state){
        @if(state.loading){
          <div class="overlay">
            <div class="spinner-border"></div>
        </div>
        }
        @else if(state.error){
        <div>
            {{state.error}}
        </div>
        }
        @else if (state.data && state.data.length>0){
        <div class="table-container">
            <table class="modal-table">
                <thead>
                    <tr>
                        <th>Company Type</th>
                        <th>Company Name / Location</th>
                        <th class="text-right">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let record of state.data; trackBy:trackByRecordId"
                        [class.selected]="selectedRecord.id === record.id">
                        <td class="font-mono">{{ record.companyType }}</td>
                        <td>
                            <div class="record-name">{{ record.companyName }}</div>
                            <div class="record-sub">{{ record.country }}</div>
                        </td>
                        <td class="text-right">
                            <button class="btn-select" [class.btn-selected]="selectedRecord.id === record.id"
                                (click)="selectRecord(record)">
                                {{ selectedRecord.id === record.id ? 'Selected' : 'Select' }}
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="state.data.length === 0">
                        <td colspan="3" class="empty-state">No records found.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        
        }
        }
        <div class="modal-footer">
            <!-- <button class="btn-secondary" (click)="createCanonRequest()">Create Canon Request</button> -->
            <button class="btn-primary" [disabled]="!selectedRecord.id" (click)="confirmMapping()">
                Confirm Mapping
            </button>
        </div>
    </div>
</div>